import React from 'react';
import PropTypes from 'prop-types';

import config from '../../../../config';

function AppLogo(props) {
    return (
        <picture>
            <img src={`${config.staticUrl}images/app/logo${props.suffix ? `-${props.suffix}` : ''}.png`} {...props} />
        </picture>
    );
}

AppLogo.defaultProps = {
    suffix: '',
};

AppLogo.propTypes = {
    suffix: PropTypes.string,
};

export default AppLogo;
